import {Component,ConnectedComponent} from 'lowkey-component'

import {MediaQuery} from '@services/MediaQuery'

export class AboutVideo extends ConnectedComponent {

  mq = MediaQuery.create()
  observer: IntersectionObserver | null = null
  color = ''
  video: HTMLVideoElement | undefined = undefined
  inner: Component | null = null
  initialTop = 0
  fullscreen: Component<HTMLAnchorElement> | null = null
  sound: Component<HTMLAnchorElement> | null = null
  fullscreenContainer: HTMLDivElement | undefined = undefined
  container: HTMLDivElement | undefined = undefined

  constructor(element: HTMLDivElement) {
    super(element)
    this.inner = this.select('.o-about-video_inner')
    this.fullscreen = this.select('.o-about-video_fullscreen')
    this.sound = this.select('.o-about-video_sound')
  }

  didMount() {
    this.video = this.element.querySelector('.o-about-video_object') as HTMLVideoElement
    // this.sound = this.element?.querySelector('.o-about-video_sound') as HTMLAnchorElement
    this.fullscreenContainer = this.element.querySelector('.o-about-video_fullscreenContainer') as HTMLDivElement
    this.container = this.element?.querySelector('.o-about-video_container') as HTMLDivElement

    const list = this.video
    const {top} = list.getBoundingClientRect()
    this.initialTop = top + window.scrollY

    if (this.inner) {
      this.observer = new IntersectionObserver(this.onIntersection, {
        rootMargin: '0px',
        threshold: [0],
      })
      this.observer.observe(this.inner.element)
    }

    this.fullscreen?.on('click', this.onPressFullscreen)
    this.sound?.on('click', this.onPressSound)

  }

  didUnmount() {
    this.observer?.disconnect()
  }


  onPressFullscreen = () => {
    this.fullscreenContainer?.classList.toggle('fullscreen')
  }

  onPressSound = () => {
    if (this.video) {
      if (this.video?.muted) {
        this.video.muted = false
        this.sound?.element.classList.remove('off')
      } else {
        this.video.muted = true
        this.sound?.element.classList.add('off')
      }
    }
  }

  onIntersection = (entries: IntersectionObserverEntry[]) => {
    if (this.fullscreenContainer?.classList.contains('fullscreen')) {
      return
    }
    for (const entry of entries) {
      // if (!entry.rootBounds) return
      const isDisabled = entry.intersectionRatio < 1
      if (isDisabled && !entry.isIntersecting) {
        this.disable()
      } else {
        this.enable()
      }
    }
  }

  enable() {
    this.video?.play()
  }

  disable() {
    this.video?.pause()
  }
}
